<template>
  <footer
    class="footer"
    translate="no"
  >
    <div class="container footer__wrapper">
      <div>
        <app-logo
          :logo="logo"
          class="logo"
        />

        <app-content
          class="color--white margin__t--18 info"
          :content="translate(info)"
        />

        <app-social-networks
          class="margin__t--42"
          :facebook="['fab', 'facebook-f']"
          :linkedin="['fab', 'linkedin-in']"
        />
      </div>

      <nav>
        <ul class="navigation__ul">
          <li
            v-for="({ link }, index) in links"
            :key="`navigation_${index}`"
            class="navigation__li"
          >
            <app-link
              :link="link"
              class="navigation__link link--naked link__color--white-prim"
            />
          </li>
        </ul>
      </nav>

      <div
        class="d-flex align-items-center"
        v-for="(partner, key) in partners"
        :key="`partner_${key}`"
      >
        <template v-if="translate(partner.logo)">
          <a
            :href="translate(partner.url)"
            target="_blank"
            v-if="translate(partner.url)"
          >
            <img
              class="partner__logo"
              :src="translate(partner.logo)"
              :alt="translate(partner.name)"
            >
          </a>

          <img
            class="partner__logo"
            :src="translate(partner.logo)"
            :alt="translate(partner.name)"
            v-else
          >
        </template>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useI18n } from '@/vendors/i18n'

import AppLogo from '&/atoms/AppLogo'
import AppSocialNetworks from '&/molecules/AppSocialNetworks'
const AppLink = defineAsyncComponent(() => import('&/atoms/AppLink'))
const AppContent = defineAsyncComponent(() => import('&/atoms/AppContent'))

const { section } = defineProps({
  section: { type: Object, required: true }
})

const { translate } = useI18n()

const { column_1 = {}, column_2 = {}, column_3 = {}, column_4 = {} } = section.attributes
const { logo = {}, text: info = {} } = column_1
const { nav: links = [] } = column_2
const partners = [column_3.partner || {}, column_4.partner || {}]
</script>

<style lang="scss" scoped>
$color--primary: #E60F8E;
$color--tertiary: #653472;
.footer {
  background: $color--tertiary;
  padding: $padding__base * 4 0;

  @include mq(sm) {
    padding-bottom: $padding__base * 6;
  }

  &__wrapper {
    display: grid;
    gap: $margin__base * 4 $margin__base * 2;
    grid-template-columns: 1fr;

    @include mq(sm) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include mq(md) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}

.info {
  font-size: rem(14px);
}

.navigation {
  &__li {
    &:not(:last-child) {
      margin-bottom: calc($margin__base / 2);
    }

    &:deep() {
      .navigation__link {
        font-size: rem(18px);
        line-height: 1.2;

        @include mq(xl) {
          font-size: rem(20px);
        }

        &.is-active {
          color: $color--primary;
        }
      }
    }
  }
}

.partner {
  &__logo {
    max-height: 190px;
    max-width: 100%;
    width: auto;
  }
}

:deep() {
  .logo {
    height: 50px;
  }

  .networks {
    &__ul {
      display: grid;
      grid-template-columns: repeat(5, 36px);
      gap: 6px 12px;

      @include mq(md) {
        gap: 6px 18px;
        grid-template-columns: repeat(4, 36px);
      }
    }

    &__li {
      &:not(:last-child) {
        margin-right: $margin__base;
      }
    }

    &__a {
      display: flex;
      width: 36px;
      height: 36px;
      justify-content: center;
      align-items: center;
      background: $color--primary;
      transition: $transition__duration;
      border-radius: 50%;
      color: $white;
      font-size: rem(16px);

      &:hover {
        background: shade($color--primary);
      }
    }
  }
}
</style>
